module.exports = __webpack_public_path__ + "static/media/eth.21d93707.png";